import { useMemo } from "react";
import { useIntl } from "react-intl";
import { mapRenderer, ReadOnlySwitchRenderer, StringRenderer } from "../../shared/renderers/table";
import { getLanguageFromFullLocale } from "../../../lib/config";
import { messages } from "../messages";
import { TableColumns } from "../../shared/crud/list";
import { InsuranceEntity } from "../entity";
import { dateToString } from "../../../lib/dateUtils";

export function useTableColumns(): TableColumns<InsuranceEntity> {
  const intl = useIntl();

  return useMemo(
    () => ({
      active: {
        renderer: ReadOnlySwitchRenderer,
        width: 100,
      },
      ticker: {
        renderer: StringRenderer,
      },
      translationsList: {
        children: {
          title: {
            renderer: mapRenderer(StringRenderer, (it, intl) => {
              if (!it || !it.length) return undefined;
              const current = it.find(t => t.locale === getLanguageFromFullLocale(intl.locale));
              return current?.name || it[0].name;
            }),
          },
        },
      },
      typology: {
        renderer: mapRenderer(StringRenderer, it => {
          if (it?.percentage) {
            return intl.formatMessage(messages.percentage);
          }
          if (it?.amount) {
            return intl.formatMessage(messages.amount);
          }
          return "";
        }),
      },
      validFrom: {
        renderer: mapRenderer(StringRenderer, it => it && dateToString(it, "dd/MM/yyyy")),
      },
      validTo: {
        renderer: mapRenderer(StringRenderer, it => it && dateToString(it, "dd/MM/yyyy")),
      },
    }),
    [intl]
  );
}
